import React, { useRef, useEffect, useState } from 'react'
import { ProductCarousel } from "./ProductCarousel"
import { CustomizeOrder } from "./CustomizeOrder"
import { MoreInfo } from "./MoreInfo"
import { ProductVideos } from "./ProductVideos"
import { QandAs } from "./QandAs"
import { CartSummary } from "./CartSummary"
import { scrollToAnchor } from './HelperFunctions';
import { AjaxPost } from "../../Services/index";
import { SimilarProducts } from "./SimilarProducts";
import { useDidMountEffect } from './CustomHooks';
import { SDFAQPage, SDQuestion, SDPerson, SDAnswer } from '../../Services/StrucuredData/StructuredDataModels';
import { StructuredDataModelFactory } from '../../Services/StrucuredData/StructuredDataEvents';

export const ProductPage = () => {
    const productDesc = useRef();
    const initialReadMoreHeight = useRef(null);
    const [activeMenu, setActiveMenu] = useState('Customize Order');
    const [items, setItems] = useState(null);
    const [updateCart, setUpdateCart] = useState(null);
    const [cartSummaryUoms, setCartSummaryUoms] = useState([]);

    useEffect(() => {
        new AjaxPost({
            type: 'get',
            endpoint: "/products/GetProductsForPurchaseSelection_byItemGroupRecNo/" + productModel.ItemGroupRecNo,
            payload: {},
            cbFunction: (dataAjax) => {
                HandleQAStructuredData(productModel.ItemGroupRecNo);
                setItems([...dataAjax.Items]);
            },
            errFunction: function (err) {
                console.log("---------GetProductsForPurchaseSelection_byItemGroupRecNo callback failed------------", err)
                $(".siteloader").removeClass('loading-heartbeat');
                $(".siteloader").text('Uh oh. Something went wrong! Please refresh this page.');
            },
            timeout: 30000
        })
    }, [])

    useEffect(() => {
        if (productDesc == null) return;
        productModel.Description = productModel.Description.split('<p style=""><span style="font-weight:normal;">&nbsp;</span></p>').join('');
        productDesc.current.innerHTML = productModel.Description;
        const description = $("#product-description");
        if (description.height() > 130) {
            initialReadMoreHeight.current = description.height();
            description.css("height", 130);
            description.css("mask", "linear-gradient(to bottom, rgba(0, 0, 0, 1) 0, rgba(0,0,0, 1) 74%, rgba(0,0,0, 0) 100%, rgba(0,0,0, 0) 0) 100% 50% / 100% 100% repeat-x");
        }
        else $("#read-more").hide();
    }, [productDesc])

    useDidMountEffect(() => {
        if (!items?.length) {
            const firstMenu = $('#product-details-menu').children().first();
            if (activeMenu === 'Customize Order') activateMenu(firstMenu.text(), firstMenu);
        }
    }, [items])

    return (<>
        <CartSummary cartSummaryUoms={cartSummaryUoms} setCartSummaryUoms={setCartSummaryUoms} updateCart={updateCart} />
        {/*Product photo and uppper desc*/}
        <div className="tw-flex tw-gap-[25px] lg:tw-gap-[40px] tw-flex-col lg:tw-flex-row">
            <div id="product-Carousel" className="product-Carousel my-2 my-lg-0 lg:tw-w-[50%]">
                <div id="product-image-carousel" className="flex-shrink-1 w-100"><ProductCarousel /></div>
            </div>
            <div className="lg:tw-w-[47%] xxxl:tw-w-[43%]">
                <div>
                    <div className="tw-text-[30px] lg:tw-text-[37px] tk-trade-gothic-next-condensed tw-font-bold tw-leading-[35px]">{productModel.Heading}</div>
                    {productModel.Brand && <div className="tw-text-[13px] tw-text-[#A2A2A2] tw-mt-[5px]">By {productModel.Brand}</div>}
                </div>
                <div onClick={() => { scrollToAnchor("#product-details-menu"); activateMenu('Customize Order', $(".customize-order")); }}
                    className="tw-cursor-pointer tw-mt-[15px] tw-mb-[22px] sm:tw-mb-[32px] tw-w-[100%] sm:tw-w-[203px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[14px]">
                    View Items
                </div>
                {/*Product description*/}
                <div className="tw-pt-[15px]" style={{ borderTop: "1px solid #C8C8C8" }}>
                    <div id="product-description" className="tw-text-[16px] tw-overflow-hidden" ref={productDesc} />
                    <div onClick={showMoreDesc} id="read-more"
                        className="arrow-hover tw-cursor-pointer tw-text-[16px] tw-font-bold tw-text-tamarillo-700 tw-mb-[25px] hover:tw-text-tamarillo-650 read-more-arrow tw-w-fit">
                        Read <span id="read-more-text">More</span>
                        <svg className="tw-w-[12px] xl:tw-w-[17px] tw-ml-[2px] tw-mb-[3px]" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 612 792" style={{ enableBackground: "new 0 0 612 792" }} xmlSpace="preserve">
                            <g>
                                <rect x="157.3" y="198.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -225.0565 249.6209)" style={{ fill: "#A71D37" }} width="63" height="396" />
                                <rect x="226.2" y="365" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -156.1355 416.0993)" style={{ fill: "#A71D37" }} width="396" height="63" />
                            </g>
                        </svg>
                    </div>
                    {/*list of documents*/}
                    {productModel.Documents.length > 0 && <>
                        <div className="tw-text-[18px] tw-font-bold tw-mb-[14px] tw-mt-[20px]">
                            Product Downloads
                        </div>
                        <div className="tw-flex tw-gap-[14px] tw-mb-[20px] sm:tw-mb-[28px] tw-max-w-full tw-flex-wrap">
                            {productModel.Documents.map((doc, i) =>
                                <div key={`document-link-${i}`}>
                                    <a href={`/Content/Docs/${doc.Name}`} title={doc.Description} target="_blank" className="tw-basis-[21%] tw-min-w-[115px] hover:tw-text-[#A71635]">
                                        <img className="tw-w-[24px] tw-m-auto" src="/Content/img/sprites/pdf-downloadred.svg" />
                                        <div className="tw-text-[13px] tw-mt-[5px] tw-text-center tw-leading-[14px] tw-max-w-[150px]">
                                            {doc.Description}
                                        </div>
                                    </a>
                                    {(i < productModel.Documents.length - 1) && <div style={{ borderRight: "1px solid #707070" }}></div>}
                                </div>
                            )}
                        </div></>
                    }
                    {/*shipping info*/}
                    <div className="tk-trade-gothic-next tw-flex tw-text-[16px] tw-p-[16px] sm:tw-p-0 sm:tw-h-[46.5px] sm:tw-items-center sm:tw-justify-evenly tw-flex-col sm:tw-flex-row tw-gap-[10px] sm:tw-gap-0 tw-bg-[#F5F5F5] sm:tw-bg-transparent"
                        style={window.innerWidth >= 576 ? { borderTop: "1px solid #C8C8C8", borderBottom: "1px solid #C8C8C8" } : {}}>
                        <div className="tw-relative tw-flex tw-gap-[12px] sm:tw-gap-[19px] lg:tw-gap-[10px] xl:tw-gap-[19px] xxxl:tw-gap-[6px] lg:tw-w-[190px] xl:tw-w-auto">
                            <img className="tw-w-[25.24px] sm:tw-w-[35px]" src="/Content/img/sprites/shipping-truck.svg" />
                            <div className="sm:tw-text-center">Free U.S. shipping over $100</div>
                        </div>
                        {window.innerWidth >= 576 &&
                            <div style={window.innerWidth >= 768 ? { height: "30px", borderRight: "1px solid #C8C8C8" } : { height: "30px", border: "1px solid #C8C8C8" }}
                                className="tw-mx-[14px] md:tw-mx-0" />}
                        <div className="tw-flex tw-gap-[19px] lg:tw-gap-[10px] xl:tw-gap-[19px] xxxl:tw-gap-[6px] lg:tw-w-[190px] xl:tw-w-auto">
                            <img className="tw-w-[23px] sm:tw-w-[26px]" src="/Content/img/sprites/box.svg" />
                            <div className="sm:tw-text-center">In stock items ship within 24 hours</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="lg:tw-mx-[20px] xl:tw-mx-[40px] tw-mt-[40px] sm:tw-mt-[90px] tw-flex tw-flex-col tk-trade-gothic-next tw-relative">
            <div className="xl:tw-px-[120px] tw-relative 
                before:tw-h-[1px] before:tw-bg-[#282828] before:tw-top-[31px] before:sm:tw-top-[41.5px] before:tw-left-0 before:tw-right-0 before:tw-m-auto before:tw-absolute
                after:tw-h-[1px] after:tw-bg-[#282828] after:sm:tw-top-full after:tw-left-0 after:tw-right-0 after:tw-m-auto after:tw-absolute">
                {/*product menu*/}
                <div id="product-details-menu" className="tw-relative tw-flex tk-trade-gothic-next-condensed tw-font-bold tw-text-[17px] sm:tw-text-[24px] sm:tw-gap-[65px] tw-justify-around sm:tw-justify-start tw-mb-[20px] lg:tw-mb-[30px] sm:tw-pb-[7px]">
                    {(items === null || !!items.length) && <div className="customize-order tw-relative tw-cursor-pointer product-page-menu-active" onClick={(e) => { activateMenu('Customize Order', e) }}>Customize Order</div>}
                    {$(productModel.Specification).text().trim() && <div className="tw-relative tw-cursor-pointer" onClick={(e) => { activateMenu('More Info', e) }}>More Info</div>}
                    {!!productModel.Videos.length && <div className="tw-relative tw-cursor-pointer" onClick={(e) => { activateMenu('Video', e) }}>Video</div>}
                    <div className="tw-relative tw-cursor-pointer" onClick={(e) => { activateMenu('Q&A', e) }}>Q&A</div>
                </div>
                <div className="tw-pb-[45px] lg:tw-pb-[110px]">
                    {(activeMenu === 'Customize Order' && (items === null || !!items.length)) && <CustomizeOrder items={items} setItems={setItems} updateCart={updateCart} setUpdateCart={setUpdateCart} />}
                    {activeMenu === 'More Info' && <MoreInfo />}
                    {activeMenu === 'Video' && <ProductVideos />}
                    {activeMenu === 'Q&A' && <QandAs />}
                </div>
            </div>

            <SimilarProducts />
        </div>
    </>);

    function showMoreDesc(e) {
        if ($("#read-more-text").text() === 'More') {
            $("#product-description").animate({ height: initialReadMoreHeight.current }, 200).css("height", "auto");
            $("#product-description").css("mask", "unset");
            $("#read-more-text").text('Less');
            $("#read-more").find('svg').toggleClass('spin-arrow');
        }
        else {
            $("#product-description").animate({ height: '130' }, 200).css("height", 130);;
            $("#product-description").css("mask", "linear-gradient(to bottom, rgba(0, 0, 0, 1) 0, rgba(0,0,0, 1) 74%, rgba(0,0,0, 0) 100%, rgba(0,0,0, 0) 0) 100% 50% / 100% 100% repeat-x");
            $("#read-more-text").text('More');
            $("#read-more").find('svg').toggleClass('spin-arrow');
        }
    }

    function activateMenu(menuNo, e) {
        $(".product-page-menu-active").removeClass("product-page-menu-active");
        $(e.target).length ? $(e.target).addClass("product-page-menu-active") : $(e).addClass("product-page-menu-active");
        setActiveMenu(menuNo);
    }

    function HandleQAStructuredData(itemGroupRecNoKey) {
        new AjaxPost({
            type: 'get',
            endpoint: "/products/GetProductStructuredData/" + itemGroupRecNoKey,
            payload: {},
            cbFunction: (structureData) => {
                if (structureData && structureData.product_QandA_StructureDataModel) {
                    let qaEntries = structureData.product_QandA_StructureDataModel;
                    if (qaEntries.length > 0) {
                        let schema = new SDFAQPage();
                        schema.mainEntity = [];
                        qaEntries.forEach((entry) => {
                            schema.mainEntity.push(GenerateQAStructuredData(entry));
                        })
                        new StructuredDataModelFactory().AddSchema(schema);
                    }
                }
            },
            errFunction: function (err) { console.log(" HandleQAStructuredData CB failed ", err) }
        })
    }

    function GenerateQAStructuredData(entry) {
        let q = new SDQuestion();
        q.author = new SDPerson();
        q.author.name = entry.Q_from;
        q.name = entry.Question;
        let a = new SDAnswer();
        a.author = new SDPerson();
        a.author.name = entry.A_from;
        a.text = entry.Answer;
        q.acceptedAnswer = a;
        return q;
    }
}